import { Injectable } from '@angular/core';

import { ProductWallpaperSpec } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductWallpaperSpecService extends TmsWebBaseEditService<ProductWallpaperSpec, ProductWallpaperSpec> {
  constructor() {
    super('WallpaperSpec', $localize`Wallpaper Spec`);
  }
}
